import { ConnectInstagramAccountDto, InstagramAccount, InstagramAuthUrl } from 'shared/interfaces/InstagramAccount';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const instagramBaseEndpoint = '/instagram';

export const InstagramService = {
  getAuthUrl: async (redirectUri: string): Promise<InstagramAuthUrl> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${instagramBaseEndpoint}/auth`,
      params: {
        redirectUri
      }
    });

    return response.data;
  },
  connectAccount: async (connectInstagramAccountDto: ConnectInstagramAccountDto): Promise<InstagramAccount> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${instagramBaseEndpoint}/connect`,
      data: connectInstagramAccountDto
    });

    return response.data;
  },
  getAllAccounts: async (): Promise<InstagramAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${instagramBaseEndpoint}/all`
    });

    return response.data;
  }
};
